module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "Death_In_the_12th_House-6.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Death_In_the_12th_House3#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("Grapes plucked from a nearly vacant vine"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Quench better than the sweetest wine")]), _vm._v(" "), _c('p', {
    staticClass: "quote-by"
  }, [_vm._v("—Marty Winebeck")]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0af778c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Death_In_the_12th_House-6.vue
// module id = 75
// module chunks = 0